/* 🤖 this file was generated by svg-to-ts */
export const matIconAlarmAdd: {
  name: 'alarm-add';
  data: string;
} = {
  name: 'alarm-add',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m17.337 1.81 4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0 1.282 1.536L3.337 7.19l-1.28-1.536zM12 4a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 4zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3z"/></svg>`
};
